import { AvailabilityTypes } from '../models/AvailabilityTypes'
import { CAATypes } from '../models/CAATypes'
import { CAARepository } from '../repositories/CAARepository'

export function listCAAForManagersCase(caaRepositoryAdapter: CAARepository) {
  return async function (params: {
    date: string
    patientId?: string
    personaName?: string
    availability?: AvailabilityTypes
    typeCAA?: CAATypes
  }) {
    return await caaRepositoryAdapter.listCAAForManagers(params)
  }
}
